module.exports = __webpack_public_path__ + "img/stripe-grey.911399a6.svg";